<template lang="pug">
	.page-not-found.admin.theme-1.p-5
		.page-error.tile
			h1
				i.fa.fa-exclamation-circle
				|  Error 404: Page not found
			p The page you have requested is not found.
			p: a.btn.btn-primary(href="javascript:window.history.back();") Go Back
			p: .btn.btn-info.text-white(@click.prevent='$router.push("/")') HOME
			//- p: router-link(to='/') HOME
</template>

<script>
export default {

  name: 'page-not-found',

  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>